export default __webpack_public_path__ + "appointments/static/media/amber.2200cc32.png";